export const timeToString = (time) => {
  const hour = Math.floor(time / 3600);
  const rest = time % 3600;
  const minut = Math.floor(rest / 60);
  const second = rest % 60;

  const hourString = hour.toString().padStart(2, 0)
  const minutString = minut.toString().padStart(2, 0)
  const secondString = second.toString().padStart(2, 0)

  return `${hourString}:${minutString}:${secondString}`;
};

export const stringToTime = (time) => {
  let hour, minut, second;
  const splited = time.split(':');

  if (splited.length === 3) {
    [ hour, minut, second ] = splited;
  }
  else {
    [ hour, minut ] = splited;
    second = 0;
  }

  return (parseInt(hour) * 60 * 60) + parseInt(minut * 60) + parseInt(second);
};

export const random = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}